import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsDefined,
  IsArray,
  IsOptional,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { SupplierCreateDto } from './supplier-create.dto';

export const SUPPLIER_RELATION_MAX_ITEMS = 200;

/**
 * Body of POST /supplier/full: the supplier plus the full set of regions and
 * representative users it starts with, persisted in one transaction.
 */
export class SupplierFullCreateDto {
  @ApiProperty({ type: () => SupplierCreateDto })
  @Expose()
  @IsDefined()
  @ValidateNested()
  @Type(() => SupplierCreateDto)
  supplier!: SupplierCreateDto;

  @ApiProperty({
    type: [String],
    format: 'uuid',
    description: 'Region ids the supplier serves (may be empty).',
  })
  @Expose()
  @IsArray()
  @ArrayMaxSize(SUPPLIER_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  regionIds!: string[];

  @ApiPropertyOptional({
    type: [String],
    format: 'uuid',
    description:
      'User ids linked as representatives; each must hold the SupplierRepresentative role.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(SUPPLIER_RELATION_MAX_ITEMS)
  @IsUUID('4', { each: true })
  representativeUserIds?: string[];
}
